import {
	Button,
	DatePicker,
	Input,
	Popconfirm,
	Select,
	Space,
	message,
} from 'antd'
import dayjs from 'dayjs'
import moment from 'moment'
import React from 'react'
import { Text } from '../../../../styles/reactnative'
import API from '../../../../utils/api'
import ExchangeName from '../../ExchangeName'
import Price from '../../PositionColumns/Price'

export const column_pairs = (
	mutate,
	usermodal,
	token,
	fold,
	edit,
	setEdit,
	shareMutate
) => {
	let editable = false

	return [
		{
			title: '구분코드',
			dataIndex: 'code',
			align: 'center',
			key: 'code',
			width: 80,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '구분이름',
			dataIndex: 'groupname',
			key: 'groupname',
			align: 'center',
			render: (text, record) => {
				return record?.edit ? (
					<Input
						size="small"
						defaultValue={text}
						onChange={e => {
							record.adminname = e.target.value
						}}
					/>
				) : (
					<Text style={{ fontWeight: 'bold' }}>{text}</Text>
				)
			},
		},
		{
			title: '거래소',
			dataIndex: 'exchange_id',
			align: 'center',
			key: 'exchange_id',
			render: (text, record) => {
				return <ExchangeName exchange_id={text} />
			},
		},
		{
			title: '종목코드',
			dataIndex: 'pairs',
			key: 'pairs',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '종목이름',
			align: 'center',
			dataIndex: 'name',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '증거금',
			align: 'center',
			children: [
				{
					title: '증거금',
					dataIndex: 'minimum_margin',
					align: 'center',
					key: 'minimum_margin',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.minimum_margin = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '로스컷',
					dataIndex: 'losscut',
					align: 'center',
					key: 'losscut',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.losscut = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '오버나잇',
					dataIndex: 'ovn_margin',
					align: 'center',
					key: 'ovn_margin',
					render: (text, record) => {
						return record?.edit ? (
							<>
								<Input
									size="small"
									defaultValue={text}
									type="number"
									onChange={e => {
										record.ovn_margin = e.target.value
									}}
								/>
								{/* <Button
									size="small"
									onClick={() => {
										if (text >= 9999999999999) {
											record.ovn_margin = 300000
										} else {
											record.ovn_margin = 9999999999999
										}
									}}>
									{text >= 9999999999999
										? '금지해제'
										: '금지처리'}
								</Button> */}
							</>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '최대계약수',
					dataIndex: 'max_amount',
					align: 'center',
					key: 'max_amount',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.max_amount = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
			],
		},
		{
			title: '수수료',
			align: 'center',
			children: [
				{
					title: '수수료',
					dataIndex: 'fee',
					align: 'right',
					key: 'fee',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.fee = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
				{
					title: '단위',
					dataIndex: 'feetype',
					align: 'left',
					width: 80,
					key: 'feetype',
					render: (text, record) => {
						return record?.edit ? (
							<Select
								defaultValue={text}
								size="small"
								options={[
									{ value: 0, label: '%' },
									{ value: 1, label: record?.feecurrency },
								]}
								onChange={e => {
									record.feetype = e
								}}
							/>
						) : (
							<Text>{text == 0 ? '%' : record?.feecurrency}</Text>
						)
					},
				},
			],
		},
		{
			title: `상장일 (오늘날짜${moment().format('MM-DD')})`,
			children: [
				{
					title: '상장일',
					dataIndex: 'startdate',
					align: 'center',
					key: 'startdate',
					render: (text, record) => {
						return record?.edit ? (
							<DatePicker
								size="small"
								onChange={e => {
									record.startdate = e?.format('YYYY-MM-DD')
								}}
								defaultValue={dayjs(
									record?.startdate,
									'YYYY-MM-DD'
								)}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
				{
					title: '만료일',
					dataIndex: 'enddate',
					align: 'center',
					key: 'enddate',
					render: (text, record) => {
						return record?.edit ? (
							<DatePicker
								size="small"
								onChange={e => {
									record.enddate = e?.format('YYYY-MM-DD')
								}}
								defaultValue={dayjs(
									record?.enddate,
									'YYYY-MM-DD'
								)}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
			],
		},
		{
			title: '관리',
			align: 'center',
			render: (text, record) => {
				return (
					<Space.Compact size="small">
						<Button
							type="primary"
							size="small"
							onClick={() => {
								if (!record?.edit) {
									record.edit = record.edit ? false : true
									setEdit(!edit)
								} else {
									API.send('PUT', '/admin/pairs', token, {
										//ov, adminname, isactive, margin, losscut, ovnmargin, max_amount, fee, feetype
										ov: record?.pairs,
										adminname: record?.adminname,
										margin: record?.minimum_margin,
										losscut: record?.losscut,
										ovnmargin: record?.ovn_margin,
										max_amount: record?.max_amount,
										fee: record?.fee,
										feetype: record?.feetype,
										startdate: record?.startdate,
										enddate: record?.enddate,
									}).then(res => {
										record.edit = record.edit ? false : true
										setEdit(!edit)
										message.success('수정되었습니다.')
										mutate(1)
										shareMutate(1)
									})
								}
							}}>
							수정
						</Button>
						<Popconfirm
							title={'삭제하시겠습니까?'}
							onConfirm={() => {
								API.delete('/admin/pairs', token, {
									ov: record?.pairs,
								}).then(res => {
									message.success('삭제되었습니다.')
									setEdit(!edit)
									mutate(1)
									shareMutate(1)
								})
							}}>
							<Button type="primary" size="small" danger>
								삭제
							</Button>
						</Popconfirm>
					</Space.Compact>
				)
			},
		},
	]
}
